export enum UserRewardStatus {
  NoAccess,
  NotEnrolled,
  Enrolled = 3
}
